import Cookies from '../shared/cookie.js';
import m from 'mithril'
import "./settings.css"


export default function SettingsContainer (vnode) { 
  var INTERFACE_STYLE =  "interfaceStyle";
  return {
    view: function() {
      var value = Cookies.get(INTERFACE_STYLE) || "auto";
      return m("div#settings-container",
        m('h3', "Interface"),
        // m('label', {for:'interfaceStyle'}, 'Interface style (beta) '),
        // m(SelectControl, {
        //   id: 'interfaceStyle',
        //   key: 'interfaceStyle',
        //   default: "auto",
        //   values: [
        //     {value:"auto", label:"Auto"},
        //     {value:"light", label:"Light"},
        //     {value:"dark", label:"Dark"},
        //   ]
        // }),
        m('p'),
        m('label', {for:'clockStyle'}, 'Clock style '),
        m(SelectControl, {
          id: 'clockStyle',
          key: 'clockStyle',
          default: "fuzzy",
          values: [
            {value:"fuzzy", label:"Fuzzy"},
            {value:"standard", label:"10:10 (12hr)"},
            {value:"standard24", label:"22:10 (24 hr)"}
          ]
        }),

        m('p'),
        m('label', {for:'screenSaverType'}, 'Screen saver '),
        m(SelectControl, {
          id: 'screenSaverType',
          key: 'screenSaverType',
          default: "none",
          values: [
            {value:"none", label:"None"},
            {value:"ig", label:"Instagram"},
            {value:"clock", label:"Clock"}
          ]
        }),

        m('p'),
        m('label', {for:'igAccount'}, 'Instagram account '),
        m(TextFieldControl, {
          id: 'igAccount',
          key: 'igAccount',
          default: "peachesvonb",
          placeholder: "peachesvonb"
        })


        
      );
    }
  }
}

function SelectControl (vnode) {
  return {
    view: function(vnode) {
      var attrs = vnode.attrs;
      var values = attrs.values;
      var selectedLabel = Cookies.get(attrs.key) || attrs.default;
      var valueNodes = values.map(function(v) {
        var options = {value:v.value} 
        if (v.value == selectedLabel) options.selected = "selected"
        return m('option', options, v.label);
      });

      return m('select',
        {id: attrs.id, onchange: function(e) { Cookies.set(attrs.key, e.target.value) }},
        valueNodes
        )
    }
  }
}


function TextFieldControl (vnode) {
  return {
    view: function(vnode) {
      var attrs = vnode.attrs;
      
      
      return m('input', {
          id: attrs.id,
          placeholder:attrs.placeholder,
          value:Cookies.get(attrs.key),
          oninput: function(e) { Cookies.set(attrs.key, e.target.value) }

        },
      )
    }
  }
}